// extracted by mini-css-extract-plugin
module.exports = {"tapestryWrapper":"cc_tapestryWrapper_1014780759","tapestryCardContent":"cc_tapestryCardContent_1014780759","bgTapestry":"cc_bgTapestry_1014780759"};